import { getObjectKeyByIndex } from 'utils';

export const isFieldComponentVisible = object => object[getObjectKeyByIndex(object)].visible;
